export const getMyBoards = <Board>(member: {
  id: string;
  idBoards: string[];
  boards: ({
    id: string;
    memberships: {
      idMember: string;
    }[];
  } & Board)[];
}) => {
  const inIdBoards = new Map<string, boolean>();
  if (member.idBoards) {
    member.idBoards.forEach((id) => inIdBoards.set(id, true));
  }

  return member.boards.filter(
    ({ id, memberships }) =>
      inIdBoards.get(id) &&
      memberships.some(({ idMember }) => idMember === member.id),
  );
};
